import React, { useState, useEffect } from "react";
import { topUp, checkBalance } from "./topUp";
import moment from "moment";
import {
  Container,
  TextField,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  FormHelperText,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  LinearProgress,
} from "@mui/material";
import "./TopupForm.css";


const TopupForm = () => {
  const accessToken = "uBEiuHBXrDfiuthssKUQFN4xyJzmWPj3";
  const [progress, setProgress] = useState(0);
  const tableTopRef = React.useRef(null);
  const [operatorId, setOperatorId] = useState("722");
  const [amount, setAmount] = useState("20");
  const [phoneNumbers, setPhoneNumbers] = useState("");
  const [results, setResults] = useState(() => {
    const savedResults = localStorage.getItem('topUpResults');
    return savedResults ? JSON.parse(savedResults) : [];
  });
  
  const [loading, setLoading] = useState(false);
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [duration, setDuration] = useState(null);
  // Add these state variables at the beginning of the TopupForm function
  const [clientId, setClientId] = useState(localStorage.getItem("clientId") || "");
  const [clientSecret, setClientSecret] = useState(localStorage.getItem("clientSecret") || "");
  const [isSaved, setIsSaved] = useState(!!(clientId && clientSecret));

  const [isReversed, setIsReversed] = useState(true);
  const storedBalance = localStorage.getItem('balance');
  const [balance, setBalance] = useState(storedBalance ? parseFloat(storedBalance) : null);
  const [time, setTime] = useState(localStorage.getItem('lastUpdatedTime') || null);
  const [currency, setCurrency] = useState(localStorage.getItem('currency') || null);
  
  useEffect(() => {
    localStorage.setItem('topUpResults', JSON.stringify(results));
  }, [results]);
  

  // Function to handle reversing
  const handleReverse = () => {
    setIsReversed(prevIsReversed => !prevIsReversed);
  };


  // Add mapping for operatorId and amount to expiry days
  const expiryMapping = {
    "722": {
      "20": 2, // 2 days for operator 722 with amount 20
      "49": 7, // 7 days for operator 722 with amount 49
      // Add other mappings as needed
    },
    // Add other operator IDs and mappings here
  };


  // New function to calculate expiry date
  const calculateExpiryDate = (operatorId, amount) => {
    const daysToAdd = expiryMapping[operatorId]?.[amount];
    if (daysToAdd) {
      return moment().add(daysToAdd, 'days').toISOString();
    }
    return null;
  };

  // New function to save expiry to the database
  const saveExpiryToDb = async (phoneNumber, expiryDate) => {
    try {
      const response = await fetch(`https://frek.cc/proxy/38.54.86.24:5000/expiry/${phoneNumber}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": accessToken,
        },
        body: JSON.stringify({
          value: expiryDate, // Use expiryDate here instead
        }),

      });

      if (response.ok) {
        console.log("POST success:", response);
        // Not sure where setDateTime is defined. Assuming it's within this component or passed as prop

      } else {
        console.error("Request failed with status:", response.status);
        return "";
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  useEffect(() => {
    const storedClientId = localStorage.getItem("clientId");
    const storedClientSecret = localStorage.getItem("clientSecret");
    if (storedClientId && storedClientSecret) {
      setClientId(storedClientId);
      setClientSecret(storedClientSecret);
    }
  }, []);

  const handleCredentialsUpdate = () => {
    localStorage.setItem("clientId", clientId);
    localStorage.setItem("clientSecret", clientSecret);
  };

  // Add this function inside the TopupForm function
  const handleSaveCredentials = () => {
    localStorage.setItem("clientId", clientId);
    localStorage.setItem("clientSecret", clientSecret);
    setIsSaved(true);
  };


  const [operatorData, setOperatorData] = useState({
    378: [5, 10, 15, 20, 30, 50, 60, 100, 115, 200, 300, 500, 1000],
    939: [10, 15, 20, 150],
    722: [10, 15, 20, 30, 49],
    723: [10, 20, 30, 50, 60, 90, 100, 150, 200, 300],
    // Add other operator IDs and their fixed amounts here
  });

  const handleOperatorIdChange = (e) => {
    setOperatorId(e.target.value);
    setAmount(""); // Clear the amount when changing operator ID
  };



  const getOperatorDescription = (operatorId) => {
    // Add your operator descriptions here
    const descriptions = {
      "378": "TNT PHILIPPINES",
      "939": "Touch Mobile Philippines Bundles",
      "722": "TNT Philippines Bundles",
      "723": "Touch Mobile Philippines",
      // ...
    };
    return descriptions[operatorId] || "";
  };

  const amountDescriptions = {
    "378": {
      "5": "5 Regular Load",
      "10": "10 Regular Load",
      "15": "15 Regular Load",
      "20": "20 Regular Load",
      "30": "30 Regular Load",
      "50": "50 Regular Load",
      "60": "60 Regular Load",
      "100": "100 Regular Load",
      "115": "115 Regular Load",
      "200": "200 Regular Load",
      "300": "300 Regular Load",
      "500": "500 Regular Load",
      "1000": "1000 Regular Load",
      // ...
    },
    "939": {
      "10": "Unli calls and texts to TM/Globe + 50 texts to all networks",
      "15": "Unlicalls & texts to TM/Globe + 50 Text to all networks",
      "20": "Unli Allnet texts + Unlicalls to TM/Globe + 100MB FB + 200MB consumable internet",
      "150": "Unli Calls to TM/Globe + Unli Allnet texts + 1.5GB each for Facebook, Instagram, & Viber",
      // ...
    },
    "722": {
      "10": "100 MB + 100 Allnet Mins + 100 Allnet Texts for 1 day",
      "15": "150 MB + 150 Allnet Mins + 150 Allnet Texts for 1 day",
      "20": "Enjoy 300 MB Open Access Data,APPS 150 MB/day for FB, ML, IG, Tiktok, Voice : Unli Trinet,SMS: Unli Allnet valid for 2 days",
      "30": "Enjoy 450 MB Open Access Data,APPS 250 MB/day for FB, ML, IG, Tiktok, Voice : Unli Trinet,SMS: Unli Allnet valid for 3 days",
      "49": "100 MB ARAW-ARAW for FB, ML, IG, Tiktok + 500 MB + Unli Allnet Calls & Texts for 7 days.",
    },
    "723": {
      "10": "10 Regular Load",
      "20": "20 Regular Load",
      "30": "30 Regular Load",
      "50": "50 Regular Load",
      "60": "60 Regular Load",
      "90": "90 Regular Load",
      "100": "100 Regular Load",
      "150": "150 Regular Load",
      "200": "200 Regular Load",
      "300": "300 Regular Load",
    },
  };

  const getAmountDescription = (operatorId, amount) => {
    return (amountDescriptions[operatorId] && amountDescriptions[operatorId][amount]) || "";
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStartTime(Date.now());

    const numbers = phoneNumbers.replace(/\n/g, ',').split(',').map(number => number.trim());
    const totalNumbers = numbers.length;
    let completedRequests = 0; // Counter for completed requests

    const chunkSize = 100; // Define the size of each chunk
    for (let i = 0; i < totalNumbers; i += chunkSize) {
        const chunk = numbers.slice(i, i + chunkSize); // Get a chunk of numbers

        // Process each number in the chunk concurrently
        chunk.forEach(async (number) => {
            setCurrentPhoneNumber(number);
            const result = await topUp(operatorId, amount, number);

            if (result.status === "SUCCESSFUL") {
                const expiryDate = calculateExpiryDate(operatorId, amount);
                if (expiryDate) {
                    await saveExpiryToDb(number, expiryDate);
                }
            }

            // Update the results state as soon as each promise is resolved
            setResults(prevResults => [...prevResults, result]);

            // Increment the completed requests counter
            completedRequests++;

            // Update progress based on completed requests
            setProgress((completedRequests / totalNumbers) * 100);
        });
    }


    // Wait for all requests to complete
    while (completedRequests < totalNumbers) {
      await new Promise(resolve => setTimeout(resolve, 100));
  }

  // Call checkBalance after all top-ups are done
  const balanceDetails = await checkBalance();
  
  // Get the current system time and format it
  const currentTime = new Date();
  const formattedTime = currentTime.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });

  // Update state and localStorage
  setBalance(balanceDetails.balance);
  setTime(formattedTime);
  setCurrency(balanceDetails.currencyCode);

  // Save balance, time, and currency in localStorage
  localStorage.setItem('balance', balanceDetails.balance);
  localStorage.setItem('lastUpdatedTime', formattedTime);
  localStorage.setItem('currency', balanceDetails.currencyCode);
setLoading(false);
setCurrentPhoneNumber("");
setProgress(0); // reset progress
setDuration(moment.duration(Date.now() - startTime).format("HH:mm:ss", { trim: false }));
};









  return (
    <Container
      style={{
        paddingTop: 1,
        paddingBottom: 1,
        paddingLeft: 1,
        paddingRight: 1,

      }}
      maxWidth="xl"
      sx={{
        paddingTop: 0,
        paddingBottom: 1,
        backgroundColor: "#b0b0b0",
      }}
    >
      <Container>
        <Grid container spacing={2} alignItems="flex-end">
          <Grid item xs={5}>
            <TextField
              label="Client ID"
              type="password"
              value={clientId}
              onChange={(e) => setClientId(e.target.value)}
              fullWidth
              margin="normal"
              InputProps={{
                style: { height: "40px", padding: "10px" },
              }}
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              label="Client Secret"
              type="password"
              value={clientSecret}
              onChange={(e) => setClientSecret(e.target.value)}
              fullWidth
              margin="normal"
              InputProps={{
                style: { height: "40px", padding: "10px" },
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleCredentialsUpdate}
              style={{
                marginBottom: "10px",
                height: "40px",

              }}
            >
              Update API
            </Button>
          </Grid>
        </Grid>
      </Container>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2} alignItems="flex-end">
          <Grid item xs={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel id="operatorId-label">Operator ID</InputLabel>
              <Select
                labelId="operatorId-label"
                value={operatorId}
                onChange={handleOperatorIdChange}
                label="Operator ID"

              >
                {Object.keys(operatorData).map((id) => (
                  <MenuItem key={id} value={id}>
                    {getOperatorDescription(id)}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText  >
                Operator ID: {operatorId}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel id="amount-label">Amount</InputLabel>
              <Select
                labelId="amount-label"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                label="Amount"
                disabled={!operatorId} // Disable the dropdown if no operator ID is selected

              >
                {operatorData[operatorId]?.map((amt) => (
                  <MenuItem key={amt} value={amt}>
                    {amt}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText  >
                Amount: {getAmountDescription(operatorId, amount)}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>

        <LinearProgress variant="determinate" value={progress} />

        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={5} sm={2}>
            <TextField
              label="Phone Numbers"
              variant="outlined"
              value={phoneNumbers}
              onChange={(e) => setPhoneNumbers(e.target.value)}
              fullWidth
              multiline
              rows={30}
              margin="normal"

            />
          </Grid>

          <Grid item xs={5} sm={1.5}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              style={{ float: "left" }}
            >
              Load
            </Button>
            {loading && (
              <>
                <CircularProgress size={20} style={{ marginLeft: 10 }} />
                <Typography style={{ marginLeft: 10, color: "black" }}>
                  Loading {currentPhoneNumber}
                </Typography>

              </>
            )}
          </Grid>
          <Grid item xs={5} sm={8.5}>
            <TableContainer
              component={Paper}
              sx={{ backgroundColor: "#b0b0b0" }} className="ResultTable" ref={tableTopRef}>
              <Grid>
                Balance: {currency} {balance ? Number(balance).toLocaleString() : 'N/A'} | Last Updated: {time} | Loaded Numbers Total: {results.length}
              </Grid>
              <Table aria-label="simple table">
                <TableHead onClick={handleReverse}>
                  <TableRow>
                    <TableCell
                      sx={{ fontSize: 13.1, fontWeight: 200 }}
                      align="center"
                      style={{
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                      }}
                    >
                      Number
                    </TableCell>
                    <TableCell
                      sx={{ fontSize: 13.1, fontWeight: 200 }}
                      align="center"
                      style={{
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                      }}
                    >
                      ID
                    </TableCell>

                    <TableCell
                      sx={{ fontSize: 13.1, fontWeight: 200 }}
                      align="center"
                      style={{
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                      }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      sx={{ fontSize: 13.1, fontWeight: 200 }}
                      align="center"
                      style={{
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                      }}
                    >
                      Amount
                    </TableCell>


                  </TableRow>
                </TableHead>
                <TableBody>
                  {(isReversed ? [...results].reverse() : results).map((result, index) => (
                    <TableRow key={index}>
                      <TableCell
                        sx={{ fontSize: 13.1, fontWeight: 200 }}
                        align="center"
                        style={{
                          paddingTop: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          paddingRight: 0,
                        }}
                      >
                        {result.phoneNumber}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: 13.1, fontWeight: 200 }}
                        align="center"
                        style={{
                          paddingTop: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          paddingRight: 0,
                        }}
                      >
                        {result.operatorId}
                      </TableCell>

                      <TableCell
                        sx={{ fontSize: 13.1, fontWeight: 200 }}
                        align="center"
                        style={{
                          paddingTop: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          paddingRight: 0,
                        }}
                      >
                        {result.status}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: 13.1, fontWeight: 200 }}
                        align="center"
                        style={{
                          paddingTop: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          paddingRight: 0,
                        }}
                      >
                        {result.deliveredAmount}
                      </TableCell>


                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </form>
    </Container>

  );

};

export default TopupForm;